module.exports = __webpack_public_path__ + "img/burger-menu.01152834.svg";